// Apolo IDE — TurnRoleIndicator (Turn Role Router, E4 / WS 4.2).
//
// The transparent "this turn was routed" chip — like Cursor showing the active
// mode. Given the latest routing decision it shows the PAPEL (role) + the short
// reason + which model the turn ran on. null, missing role, or role 'none'
// (no clear signal) ⇒ renders NOTHING (the turn was not routed).
//
// HOUSE STYLE (Pedro): neutral surface, color ONLY on the role icon; the risky
// role gets the warning tint (it tightened to ask-mode). No per-item colored
// border (those read as errors under macOS Increase Contrast). No emoji; a11y
// label on the chip.

import { ScanSearch, Hammer, ShieldAlert, MessageCircle, Sparkles } from 'lucide-react';

const ROLE_META = {
  analysis: { label: 'análise', Icon: ScanSearch, tone: 'accent' },
  build: { label: 'build', Icon: Hammer, tone: 'neutral' },
  risky: { label: 'arriscado', Icon: ShieldAlert, tone: 'warning' },
  chat: { label: 'conversa', Icon: MessageCircle, tone: 'accent' },
};

/**
 * @param {{ decision?: {
 *   role?: string, reason?: string,
 *   readOnly?: boolean, permissionsMode?: 'ask'|null,
 *   modelId?: string,
 * } | null }} props
 */
export default function TurnRoleIndicator({ decision }) {
  const role = decision && decision.role;
  const meta = decision?.auto ? { label: 'Auto', Icon: Sparkles, tone: 'accent' } : role ? ROLE_META[role] : null;
  // null / unknown / 'none' ⇒ nothing rendered (turn not routed).
  if (!meta) return null;

  const { label, Icon, tone } = meta;
  const iconTone =
    tone === 'warning'
      ? 'text-apolo-warning'
      : tone === 'accent'
        ? 'text-apolo-accent'
        : 'text-apolo-textTertiary';

  return (
    <div
      className="flex items-center gap-2 rounded-md border border-apolo-borderSubtle bg-apolo-surface2 px-2.5 py-1.5 text-xs text-apolo-textSecondary transition hover:translate-x-0.5 hover:bg-apolo-surface3"
      role="status"
      aria-label={`Turno roteado por papel: ${label}. ${decision.reason || ''}`.trim()}
      data-turn-role={role}
    >
      <Icon size={13} aria-hidden="true" className={`shrink-0 ${iconTone}`} />
      <span className="font-medium text-apolo-textPrimary">{label}</span>
      {decision.reason && (
        <span className="min-w-0 truncate text-apolo-textTertiary" title={decision.reason}>
          {decision.reason}
        </span>
      )}
      {decision.modelId && (
        <code className="ml-auto shrink-0 truncate text-[11px] text-apolo-textTertiary" title={decision.modelId}>
          {decision.modelId}
        </code>
      )}
    </div>
  );
}
